import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-sm p-8">
        <Link to="/" className="text-sm text-[#68caf1] hover:underline mb-6 inline-block">← Back to Home</Link>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
        <p className="text-sm text-gray-400 mb-8">Last updated: October 29, 2026</p>

        <div className="space-y-6 text-sm text-gray-700 leading-relaxed">
          <section>
            <h2 className="font-semibold text-gray-900 mb-2">1. Information We Collect</h2>
            <p>When you book a service or use our website, we collect your name, email address, phone number, vehicle information, and service address. We use this information solely to provide and confirm detailing services.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">2. SMS Communications</h2>
            <p>By providing your phone number and checking the SMS consent box during booking, you agree to receive text messages from Monarch Detailing. These messages include:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Appointment confirmations and reminders</li>
              <li>En-route notifications when your detailer is on the way</li>
              <li>Invoice delivery and payment links</li>
              <li>Service completion updates</li>
            </ul>
            <p className="mt-2">Message and data rates may apply. You may opt out at any time by replying <strong>STOP</strong> to any message. For help, reply <strong>HELP</strong>.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">3. How We Use Your Information</h2>
            <p>We use your information to schedule and complete your service, send booking confirmations, process payments, and communicate about your appointment. We do not sell your personal information. We do share limited, hashed data with Meta for ad measurement as described in section 4.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">4. Advertising &amp; Analytics (Meta Pixel)</h2>
            <p>We use the Meta (Facebook) Pixel and Meta's Conversions API to measure how our ads perform. When you visit our site, Meta may receive your browsing activity (pages viewed, whether you started or completed a booking and the deposit amount), your IP address and browser information, and cookie identifiers. When you complete a booking, we also send Meta your email address, phone number and name in hashed (one-way encrypted) form so it can match the booking to the ad that led to it. We also save the ad campaign details from the link you clicked (such as UTM tags) with your booking.</p>
            <p className="mt-2">This data is used only to measure and improve our advertising. You can control ad personalization in your Facebook ad settings, block cookies in your browser, or email us to ask that we stop sending your booking data to Meta.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">5. Payment Information</h2>
            <p>Payments are processed securely through Stripe. We do not store your full credit card number on our servers.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">6. Data Retention</h2>
            <p>We retain your booking and contact information for up to 3 years for service history and business records. You may request deletion of your data by emailing info.monarchdetailing@gmail.com.</p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">7. Contact</h2>
            <p>Questions about this policy? Email us at <a href="mailto:info.monarchdetailing@gmail.com" className="text-[#68caf1] hover:underline">info.monarchdetailing@gmail.com</a> or visit <a href="https://www.monarchdetailing.art" className="text-[#68caf1] hover:underline">monarchdetailing.art</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
